/**
 * filterSelect — Alpine.js component for a styleable custom dropdown.
 *
 * Standalone version — Alpine.js must be loaded globally before this script.
 *
 * Wraps a hidden <select class="filter-select"> so that filtering.js
 * (which relies on .filter-select change events, FormData, and
 * selectedIndex resets) continues to work without modification.
 *
 * Usage in HTML: data-x-data="filterSelect"
 * Expects: a sibling <select class="filter-select"> inside the same wrapper element.
 */
document.addEventListener('alpine:init', () => {
    Alpine.data('filterSelect', () => ({
        open: false,
        label: '',
        selectedValue: '',
        _select: null,

        init() {
            this._select = this.$el.querySelector('select.filter-select');
            if (!this._select) return;

            // Set initial display label from whichever option is pre-selected.
            const idx = this._select.selectedIndex;
            this.label = this._select.options[idx]?.text || '';
            this.selectedValue = this._select.value || '';

            // When filtering.js calls form.reset() (clear button), sync display.
            const form = this.$el.closest('form');
            if (form) {
                form.addEventListener('reset', () => {
                    this.$nextTick(() => {
                        this.label = this._select.options[0]?.text || '';
                        this.selectedValue = '';
                        this.open = false;
                    });
                });
            }
        },

        /**
         * Called when the user clicks an option.
         * Updates display state, syncs the hidden select, and fires a change
         * event so filtering.js triggers an AJAX fetch.
         *
         * @param {string} value - The option value (empty string = "All")
         * @param {string} label - The human-readable label to display
         */
        choose(value, label) {
            this.label = label;
            this.selectedValue = value;
            this.open = false;

            if (this._select) {
                this._select.value = value;
                this._select.dispatchEvent(new Event('change', { bubbles: true }));
            }
        },
    }));
});
